import React, { Fragment, useEffect, useState, } from "react";
import { useForm } from "react-hook-form";
import * as Yup from 'yup';
import { Link } from "react-router-dom";
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../FieldComponets/Spinner";
import { BASE_URL, url } from "../../Config/Config";
import ProfileInfo from "../Profile/Profileinfo";
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { AdminChangePasswordAction, AdminDetailProfileAction } from "../../Redux/Action/AuthAction";
import ToastDefault from "../FieldComponets/Toast";
import { Toast } from "react-toastify/dist/components";
import { getItemFromStorage ,removeItemFromStorage } from "../../utils/Helper";
import { StorageConstant } from "../../Constants/Constants";



function ChangePassword() {
    
    const dispatch = useDispatch<any>();
    const [oldPasswordType, setOldPasswordType] = useState(false);
    const [passwordType, setPasswordType] = useState(false);
    const [confirmPasswordType, setConfirmPasswordType] = useState(false);
    const UpdateChangePassword = useSelector((state: any) => state.AdminChangePasswordState);

    const formSchema = Yup.object().shape({
        old_password: Yup.string()
            .required(VALIDATION_MESSAGE?.OLD_PASSWORD_REQUIRED)
            .min(8, VALIDATION_MESSAGE?.OLD_PASSWORD_MIN_CHAR)
            .max(16, VALIDATION_MESSAGE?.OLD_PASSWORD_MAX_CHAR)
            .matches(/^\S*$/, VALIDATION_MESSAGE?.NO_SPACE_ALLOWED)
            .matches(/^(?=.*[A-Z])/, VALIDATION_MESSAGE?.PASSWORD_UPPER_CASE)
            // .matches(/^(?=.*[!@#\$%\^&\*])/, VALIDATION_MESSAGE?.PASSWORD_SPECIAL_CASE)
            .matches(/^(?=.*[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~])/, VALIDATION_MESSAGE?.PASSWORD_SPECIAL_CASE)
            .matches(/^(?=.{6,20}$)\D*\d/, VALIDATION_MESSAGE?.PASSWORD_NUMBER_CASE),


        password: Yup.string()
            .required(VALIDATION_MESSAGE?.NEW_PASSWORD_REQUIRED)
            .min(8, VALIDATION_MESSAGE?.NEW_PASSWORD_MIN_CHAR)
            .max(16, VALIDATION_MESSAGE?.NEW_PASSWORD_MAX_CHAR)
            .matches(/^\S*$/, VALIDATION_MESSAGE?.NO_SPACE_ALLOWED)
            .matches(/^(?=.*[a-z])(?=.*[A-Z])/, VALIDATION_MESSAGE?.PASSWORD_SPECIAL_CASE) // Ensure at least one uppercase and one lowercase letter

            // .matches(/^(?=.*[A-Z])/, VALIDATION_MESSAGE?.PASSWORD_UPPER_CASE)
            // .matches(/^(?=.*[a-z])/, "Password must be at least 1 lower case.") // Ensure at least one lowercase letter
            .matches(/^(?=.*[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~])/, VALIDATION_MESSAGE?.PASSWORD_SPECIAL_CASE)
            .matches(/^(?=.{6,20}$)\D*\d/, VALIDATION_MESSAGE?.PASSWORD_NUMBER_CASE)
            .test('password-match', 'New password cannot be  same as the old password', function (value) {
                return value !== this.parent.old_password;
            }),


        confirm_password: Yup.string()
            .required(VALIDATION_MESSAGE?.CONFIRM_NEW_PASSWORD_REQUIRED)
            .min(8, VALIDATION_MESSAGE?.CONFIRM_NEW_PASSWORD_MIN_CHAR)
            .max(16, VALIDATION_MESSAGE?.CONFIRM_NEW_PASSWORD_MAX_CHAR)
            .matches(/^\S*$/, VALIDATION_MESSAGE?.NO_SPACE_ALLOWED)
            .matches(/^(?=.*[a-z])/, "Password must be at least 1 lower case") // Ensure at least one lowercase letter

            .matches(/^(?=.*[A-Z])/, VALIDATION_MESSAGE?.PASSWORD_UPPER_CASE)
            .matches(/^(?=.*[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~])/, VALIDATION_MESSAGE?.PASSWORD_SPECIAL_CASE)
            .matches(/^(?=.{6,20}$)\D*\d/, VALIDATION_MESSAGE?.PASSWORD_NUMBER_CASE)
            .oneOf([Yup.ref('password')], VALIDATION_MESSAGE?.PASSWORD_CPWD_NOT_MATCHED),
    })




    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            old_password: "",
            password: "",
            confirm_password: ""
        }
    });

    useEffect(() => {
        dispatch(AdminDetailProfileAction({}))
    }, [dispatch])


    const onSubmit = async (payload: any) => {
        dispatch(AdminChangePasswordAction(payload));
    };

    useEffect(() => {
        if (UpdateChangePassword?.status) {
            dispatch(AdminChangePasswordAction('RESET'));
            reset();
            setTimeout(() => {
                removeItemFromStorage(StorageConstant?.is_admin_login_token);
                 window.location.href = BASE_URL + "/"
            }, 1000);
        }
    }, [dispatch, UpdateChangePassword?.status])
    return (
        <Fragment>
            {UpdateChangePassword?.loading ? <Spinner /> : ""}
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0 font-size-18">Change Password</h4>
                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item active"><Link to={url + "/dashboard"}>Dashboard</Link></li>
                                            <li className="breadcrumb-item active">Change Password</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <ProfileInfo />
                            <div className="col-xl-8">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="">
                                            <h4 className="page-title"> Update Password</h4>
                                            <form onSubmit={handleSubmit(onSubmit)} className="card" encType="multipart/form-data">
                                                <div className="pt-4 p-md-4">
                                                    <div className="row p-2">
                                                        <div className="form-group col-md-9 col-lg-6">
                                                            <label htmlFor="old_password">Old Password<span>*</span></label>
                                                            <div className="input-group">
                                                                <input
                                                                    type={oldPasswordType ? "text" : "password"}
                                                                    className="form-control m-0"
                                                                    id="old_password"
                                                                    placeholder="Password"
                                                                    minLength={8}
                                                                    maxLength={16}
                                                                    {...register('old_password')}
                                                                />
                                                                <button className="btn btn-light " type="button" onClick={() => { setOldPasswordType(!oldPasswordType); }} ><i className={`${oldPasswordType ? "mdi mdi-eye-outline" : "mdi mdi-eye-off-outline"}`}  ></i></button>
                                                            </div>
                                                            <p className="text-danger">{errors?.old_password?.message ?? UpdateChangePassword?.error?.errors?.old_password?.message}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row p-2">
                                                        <div className="form-group col-md-9 col-lg-6">
                                                            <label htmlFor="password">New Password<span>*</span></label>
                                                            <div className="input-group">
                                                                <input
                                                                    type={passwordType ? "text" : "password"}
                                                                    className="form-control m-0"
                                                                    id="password"
                                                                    placeholder="Password"
                                                                    minLength={8}
                                                                    maxLength={16}
                                                                    {...register('password')}
                                                                />
                                                                <button className="btn btn-light " type="button" onClick={() => { setPasswordType(!passwordType); }} ><i className={`${passwordType ? "mdi mdi-eye-outline" : "mdi mdi-eye-off-outline"}`}  ></i></button>
                                                            </div>
                                                            <p className="text-danger">{errors?.password?.message ?? UpdateChangePassword?.error?.errors?.password?.message}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row p-2">
                                                        <div className="form-group col-md-9 col-lg-6">
                                                            <label htmlFor="confirm_password">Confirm Password<span>*</span></label>
                                                            <div className="input-group">
                                                                <input
                                                                    type={confirmPasswordType ? "text" : "password"}
                                                                    className="form-control m-0"
                                                                    id="confirm_password"
                                                                    placeholder="Confirm Password"
                                                                    minLength={8}
                                                                    maxLength={16}
                                                                    {...register('confirm_password')}
                                                                />
                                                                <button className="btn btn-light " type="button" onClick={() => { setConfirmPasswordType(!confirmPasswordType); }} ><i className={`${confirmPasswordType ? "mdi mdi-eye-outline" : "mdi mdi-eye-off-outline"}`}  ></i></button>
                                                            </div>
                                                            <p className="text-danger">{errors?.confirm_password?.message ?? UpdateChangePassword?.error?.errors?.confirm_password?.message}</p>
                                                        </div>
                                                    </div>
                                                    <div className="mt-3 p-2">
                                                        <button type="submit" className="btn btn-primary">Update</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    );
}

export default ChangePassword;

